import { WritableSignal } from '@angular/core';

import { PivotSettings } from '@models/trial-attributes/trial-attributes';

import { BalanceSheetAttributesContext } from '../../../services/balance-sheet-attributes.context';
import { BalanceSheetPoAttributeContext } from '../../../services/balance-sheet-po-attribute.context';
import { BalanceSheetProgramProjectContext } from '../../../services/balance-sheet-program-project.context';

export const BalanceSheetEntitySettingsKeys = {
  ACCOUNTS_PAYABLE: 'ACCOUNTS_PAYABLE',
  ACCRUED_LIABILITIES: 'ACCRUED_LIABILITIES',
  LONG_TERM_PREPAID: 'LONG_TERM_PREPAID',
  PREPAID_EXPENSES: 'PREPAID_EXPENSES',
  SHORT_TERM_PREPAID: 'SHORT_TERM_PREPAID',
} as const;

export type BalanceSheetEntitySettings = {
  [key in keyof typeof BalanceSheetEntitySettingsKeys]: BalanceSheetEntitySettingsRow;
};

export const BalanceSheetEntitySettingsLabels = {
  [BalanceSheetEntitySettingsKeys.ACCOUNTS_PAYABLE]: 'AP Manual (Clearing)',
  [BalanceSheetEntitySettingsKeys.ACCRUED_LIABILITIES]: 'Accrued Liabilities',
  [BalanceSheetEntitySettingsKeys.LONG_TERM_PREPAID]: 'Long Term Prepaid',

  // these two have the same label and value, but different keys
  [BalanceSheetEntitySettingsKeys.PREPAID_EXPENSES]: 'Short Term Prepaid',
  [BalanceSheetEntitySettingsKeys.SHORT_TERM_PREPAID]: 'Short Term Prepaid',
} as const;

export interface BalanceSheetAccount {
  attributes: Record<string, string>;
  program: string;
  project: string;
  type: keyof typeof BalanceSheetEntitySettingsKeys;
}

export interface BalanceSheetEntitySettingsRow {
  ACCOUNT: string;
  attributes: Record<string, string>;
  DEPARTMENT: string;
  PROGRAM: string;
  PROJECT: string;
}

export interface GridConfigOptions {
  attributesContext: BalanceSheetAttributesContext;
  flags: {
    journalEntryApManualClearing: boolean;
  };
  headerState: WritableSignal<
    Record<
      string,
      {
        added: boolean;
        deleted: boolean;
        renamed: boolean;
        renamedValue: string;
      }
    >
  >;
  onAttributeDelete: (attributeName: string) => void;
  onAttributeRename: (attributeName: string, newName: string) => void;
  pivotSettings: PivotSettings;
  poAttributeContext: BalanceSheetPoAttributeContext;
  programProjectContext: BalanceSheetProgramProjectContext;
}
